import styled, { css } from "styled-components";
import { IPillProps } from "@template/components/Pill/index.tsx";
import { ColorKey } from "@template/theme/types/color.type.ts";

export const PillText = styled.p`
  font-style: normal;
  line-height: normal;
  font-weight: 500;
  text-transform: uppercase;
`;

export const PillWrapper = styled.div<{
  $variant: IPillProps["variant"];
  $color: ColorKey;
  $size: IPillProps["size"];
}>`
  ${({ $variant, $color, $size, theme }) => {
      const colorStore = theme.colors[$color];

      let fontSize = 0;
      let fontColor = colorStore[900];
      let backgroundColor = "";
      let padding = "";
      let outlineColor = "";

      switch ($variant) {
          case "solid":
              backgroundColor = colorStore.default;
              fontColor = theme.colors.base;
              break;
          case "flat":
              backgroundColor = colorStore[200];
              break;
          case "ghost":
              backgroundColor = colorStore[50];
              break;
          case "outline":
              fontColor = colorStore.default;
              outlineColor = colorStore.default;
              break;
          case "light":
              backgroundColor = "transparent";
              fontColor = colorStore.default;
              break;
      }

      switch ($size) {
          case "sm":
              fontSize = 12;
              padding = "2px 8px";
              break;
          case "md":
          default:
              fontSize = 14;
              padding = "4px 12px";
              break;
      }

      return css`
      outline: 1px solid ${outlineColor || "transparent"};
      padding: ${padding};
      font-size: ${fontSize}px;
      color: ${fontColor};
      background: ${backgroundColor};
    `;
  }}
  cursor: default;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: fit-content;
`;
